import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-switch-lang';

class WebChatSettings extends Component {
  render() {
    return (
      <section>
        <p>WebChatSettings</p>
      </section>
    );
  }
}

WebChatSettings.propTypes = {};

export default translate(WebChatSettings);
